<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E%E5%8A%A0%E4%BF%9D%E7%94%B3%E8%AB%8B%E5%90%8D%E5%86%8A
     -->
<!-- 新增加保申請名冊 -->
<template>
	<div class="row">
		<div class="col-12">
			<div class="col-block">
				<div class="block-header has-border">
					<h3>
						<strong>加保作業</strong>
					</h3>
				</div>
				<div class="block-content">
					<el-tabs type="border-card">
						<el-tab-pane label="基本資料">
							<el-form label-position="top">
								<el-form-item label="申請方案">
									<el-select
										v-model="recordToEdit.insPlanYearId"
										placeholder="請選擇"
										:disabled="isSubmit"
									>
										<el-option
											v-for="(item, index) in yearData"
											:key="index"
											:label="item.year"
											:value="item.id"
										></el-option>
									</el-select>
									<el-select
										v-model="recordToEdit.insPlanSubId"
										placeholder="請選擇"
										class="ml10"
										:disabled="isSubmit"
									>
										<el-option
											v-for="(item, index) in subData"
											:key="index"
											:label="item.name"
											:value="item.id"
										></el-option>
									</el-select>
									<br />
									<!-- <h3>
                                        <b>互助費 : {{subFee}}</b>
                                    </h3>-->
								</el-form-item>

								<ListForm
									:id="id"
									labelPosition="top"
									:recordToEdit="recordToEdit"
									:formType="formType"
									ref="memberGet"
									class="listFormSet"
								>
									<div
										slot="footer"
										class="dialog-footer"
									></div>
								</ListForm>

								<el-form-item
									label="確認申請人資料"
									v-show="show"
								>
									<el-button plain @click="goMember"
										>開啟申請人個人資訊</el-button
									>
									<span style="color: red" class="ml10">
										{{ member.applyTypeStr }}
									</span>
									<table
										class="table table-bordered mb-0 mt10 info"
									>
										<tbody>
											<tr>
												<td>社號</td>
												<td>{{ member.coopCode }}</td>
											</tr>
											<tr>
												<td>帳號</td>
												<td>{{ member.account }}</td>
											</tr>
											<tr>
												<td>姓名</td>
												<td>{{ recordToEdit.name }}</td>
											</tr>
											<tr>
												<td>性別</td>
												<td>
													<el-radio-group
														v-model="
															recordToEdit.sex
														"
													>
														<el-radio
															v-for="(
																gender, index
															) in genderData"
															:key="index"
															:label="
																gender.value
															"
															disabled
															>{{
																gender.label
															}}</el-radio
														>
													</el-radio-group>
												</td>
											</tr>
											<tr>
												<td>
													證件號碼 (身分證/居留證等)
												</td>
												<td>
													{{ recordToEdit.idNumber }}
												</td>
											</tr>
											<tr>
												<td>出生年月</td>
												<td>
													<div class="date mt10">
														<input
															type="text"
															class="min_go_date birthday1 birthday"
															placeholder="選擇日期"
															disabled
														/>
														<span
															class="el-input__prefix"
														>
															<i
																class="el-icon-date"
															></i>
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>職業</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.job
														"
														:disabled="isSubmit"
													></el-input>
												</td>
											</tr>
											<tr>
												<td>職稱</td>
												<td>
													<el-input
														class="mt10 mb10"
														v-model="
															recordToEdit.title
														"
														:disabled="isSubmit"
													></el-input>
												</td>
											</tr>
										</tbody>
									</table>
								</el-form-item>
								<el-form-item label="受益人分配方式">
									<el-radio-group
										v-model="recordToEdit.bnfType"
										:disabled="isSubmit"
									>
										<el-radio
											v-for="(item, index) in bnf"
											:key="index"
											:label="item.value"
											>{{ item.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="獎勵或補助/其他扣除金額">
									<el-input
										v-model="recordToEdit.subsidyAmount"
										placeholder="請輸入金額"
										style="width: 220px"
										:disabled="isSubmit"
										v-on:input="
											resetAmount(
												recordToEdit.subsidyAmount
											)
										"
									>
										<template slot="prepend">NT $</template>
									</el-input>
								</el-form-item>
								<el-form-item
									label="預計生效日"
									v-if="member.applyTypeStr != '新加保'"
								>
									<el-select
										class="el-select"
										placeholder="請選擇預計生效日"
										v-model="recordToEdit.insEffectiveDate"
										:disabled="isSubmit"
									>
										<el-option
											:value="item"
											:label="$transferDate(item)"
											v-for="item of effectiveDataList"
											:key="item"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="付款方式">
									<el-select
										class="el-select"
										placeholder="請選擇付款方式"
										v-model="recordToEdit.memberPayType"
										:disabled="isSubmit"
										@change="getBalance()"
									>
										<el-option
											:value="item.value"
											:label="item.label"
											v-for="item of enumData.insPlanPayMethod"
											:key="item.value"
										></el-option>
									</el-select>
									<!-- 備轉金才顯示社員 -->
									<el-select
										v-if="showMemberGroupSelect"
										class="el-select ml10"
										placeholder="請選擇社員"
										v-model="
											recordToEdit.insPlanPaySourceMemberId
										"
										:disabled="isSubmit"
										@change="getBalance(recordToEdit.insPlanPaySourceMemberId)"
									>
										<el-option
											:value="item.id"
											:label="`${item.account} ${item.name}`"
											v-for="item of enumData.memberGroup"
											:key="item.id"
										></el-option>
									</el-select>
								</el-form-item>
								<!-- 現金沒有結餘 -->
								<el-form-item
									label="結餘"
									v-if="recordToEdit.memberPayType !== 1"
									>{{
										$addcomma(recordToEdit.balance)
									}}</el-form-item
								>
							</el-form>
							<el-button
								type="primary"
								v-if="!isSubmit"
								:disabled="memberInfoError"
								@click="saveMainEdit"
								>暫存</el-button
							>
							<el-button
								type="primary"
								v-if="!isSubmit && id !== 'new'"
								:disabled="memberInfoError"
								@click="submit"
								>送出</el-button
							>
							<el-button @click="back">取消</el-button>
						</el-tab-pane>
						<el-tab-pane
							label="受益人資料"
							v-if="id !== 'new' && listDisplay"
						>
							<workbench
								:api="apiBnf"
								:query="query"
								:columns="
									columns[recordToEdit.bnfType == 0 ? 0 : 1]
								"
								:toolbar="toolbar"
								ref="workbench"
								@editData="editData"
								@addData="editData"
								@enumData="getBnfEnumData"
							></workbench>
							<el-dialog
								title="受益人設定"
								:visible.sync="dialogListForm"
								:modal-append-to-body="false"
								:append-to-body="true"
							>
								<el-form
									:model="currentEdit"
									label-position="top"
									ref="ruleForm"
									:rules="rules"
								>
									<el-form-item
										label="順位"
										prop="bnfSeq"
										v-if="recordToEdit.bnfType == 0"
									>
										<el-input-number
											:min="0"
											v-model="currentEdit.bnfSeq"
										></el-input-number>
									</el-form-item>
									<el-form-item label="姓名" prop="name">
										<el-input
											v-model="currentEdit.name"
										></el-input>
									</el-form-item>
									<el-form-item label="關係" prop="relation">
										<el-select
											v-model="currentEdit.relation"
											placeholder="請選擇關係"
										>
											<el-option
												v-for="(
													item, index
												) in bnfDataList"
												:key="index"
												:label="item.label"
												:value="item.value"
											></el-option>
										</el-select>
										<el-input 
											v-show="currentEdit.relation == 7"
											v-model="currentEdit.relationOther"
											placeholder="請輸入其他關係"
											class="ml-2 w-auto"
										></el-input>
									</el-form-item>
									<el-form-item label="原因" prop="reason">
										<el-input
											v-model="currentEdit.reason"
										></el-input>
									</el-form-item>
									<strong style="color: red"
										>提醒:如是兄弟姊妹或其他，原因必填</strong
									>
									<el-form-item
										label="身分證字號"
										prop="idNumber"
									>
										<el-input
											v-model="currentEdit.idNumber"
										></el-input>
									</el-form-item>
									<el-form-item label="電話" prop="phone">
										<el-input
											v-model="currentEdit.phone"
										></el-input>
									</el-form-item>
									<el-form-item label="住址" prop="addr">
										<el-input
											v-model="currentEdit.addr"
										></el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogListForm = false"
										>取消</el-button
									>
									<el-button
										type="primary"
										@click="submitForm('ruleForm')"
										>確定</el-button
									>
								</div>
							</el-dialog>
						</el-tab-pane>
						<el-tab-pane label="申請結果" v-if="isSubmit">
							<el-form label-position="top">
								<el-form-item label="申請日期">
									{{
										$transferDate(recordToEdit.sendGenDate)
									}}
								</el-form-item>
								<el-form-item label="協會送件日期">
									{{
										$transferDate(recordToEdit.genSendDate)
									}}
								</el-form-item>
								<el-form-item label="協會送件郵局存根條碼">
									<el-input
										v-model="recordToEdit.genSendCode"
										:disabled="true"
									></el-input>
								</el-form-item>
								<el-form-item label="核保狀態">
									{{
										underwriteStatusAdd[
											recordToEdit.underwriteStatus
										]+'-'+recordToEdit.insurerStatus
									}}
								</el-form-item>
								<!--如果不是加保通過就不顯示-->
								<el-form-item
									label="保險卡狀態"
									v-if="recordToEdit.underwriteStatus == 1"
								>
									<el-radio-group
										v-model="recordToEdit.insCardSendStatus"
									>
										<el-radio
											v-for="(
												cardSend, index
											) in cardSendStatus"
											:key="index"
											:label="cardSend.value"
											>{{ cardSend.label }}</el-radio
										>
									</el-radio-group>
								</el-form-item>
								<el-form-item
									v-if="recordToEdit.underwriteStatus === 1"
									label="保險卡寄送日期"
								>
									{{
										$transferDate(
											recordToEdit.insCardSendDate
										)
									}}
								</el-form-item>
								<el-form-item
									v-if="recordToEdit.underwriteStatus === 1"
									label="生效日期"
								>
									{{
										$transferDate(
											recordToEdit.insEffectiveDate
										)
									}}
								</el-form-item>
								<el-form-item
									v-if="recordToEdit.underwriteStatus === 1"
									label="保險公司實收保費"
									>{{
										recordToEdit.realPremium || 0
									}}</el-form-item
								>
								<el-form-item
									v-if="recordToEdit.underwriteStatus === 2"
									label="退費狀態"
									>{{
										refoundStatus[
											recordToEdit.refoundStatus
										]
									}}</el-form-item
								>
								<el-form-item
									label="退費金額"
									v-if="recordToEdit.underwriteStatus === 2"
									>{{ recordToEdit.backAmount }}</el-form-item
								>
								<el-form-item label="補件狀態">
									{{ addDocStatus[recordToEdit.needAddDoc] }}
								</el-form-item>
								<el-form-item
									label="補件通知內容"
									v-if="recordToEdit.needAddDoc === 1"
								>
									{{ addDocNotices[0].noticeData }}
									<br />
									{{ addDocNotices[0].updateTime }}
								</el-form-item>
							</el-form>
							<el-button type="primary" @click="sendCardSendDate"
								>送出保險卡狀態</el-button
							>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";
import ListForm from "@/components/ListForm.vue";
export default {
	name: "agent_plusroster_edit",
	components: {
		Workbench,
		ListForm,
	},
	data() {
		return {
			showMemberGroupSelect: false,
			id: this.$route.params.subId,
			api: "coopInsPlanMemberApply",
			apiBnf: "coopInsPlanMemberApplyBnf",
			recordToEdit: {
				id: "",
				name: "",
				sex: "",
				idNumber: "",
				birthday: "",
				age: "",
				title: "",
				job: "",
				bnfType: 1,
				memberId: 0,
				balance: 0,
			},
			formType: [
				{
					label: "選擇申請人",
					key: "memberId",
					type: "chooseMember",
					returnKey: "id",
					// 送出後改由 getData 打開，先宣告才有反應性
					disabled: false,
					filter: {
						isExit: 0,
						isFormal: 1,
					},
				},
				{
					slot: "buttonSlot",
					type: "slot",
				},
			],
			toolbar: {},
			isSubmit: false,
			dialogListForm: false,
			currentEdit: {
				bnfSeq: "",
				name: "",
				relation: "",
				relationOther: "",
			},
			effectiveDataList: {},
			member: {},
			addDocStatus: {},
			underwriteStatusAdd: {},
			cardSendStatus: {},
			refoundStatus: {},
			addDocNotices: [{ noticeData: "", updateTime: "" }],
			bnf: {},
			bnfDataList: {},
			data: [],
			yearData: {},
			subDataList: {},
			subData: {},
			genderData: {},
			setTimeKey: ["birthday"],
			subFee: 0,
			// 初次載入中，避免 recordToEdit 各欄位的 watcher 重複查詢社員資料
			isInitLoading: false,
			query: {
				insPlanMemberApplyId:
					this.$route.params.subId == "new"
						? 0
						: this.$route.params.subId,
			},
			columns: [
				[
					{
						label: "順位",
						prop: "bnfSeq",
					},
					{
						label: "身分證字號",
						prop: "idNumber",
					},
					{
						label: "姓名",
						prop: "name",
					},
					{
						label: "關係",
						prop: "relation",
						renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
					},
					{
						label: "電話",
						prop: "phone",
					},
					{
						label: "住址",
						prop: "addr",
					},
					{
						prop: "updateTime",
						label: "最後修改",
					},
					{
						prop: "updateUserName",
						label: "最後修改人員",
					},
				],
				[
					{
						label: "身分證字號",
						prop: "idNumber",
					},
					{
						label: "姓名",
						prop: "name",
					},
					{
						label: "關係",
						prop: "relation",
						renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
					},
					{
						label: "電話",
						prop: "phone",
					},
					{
						label: "住址",
						prop: "addr",
					},
					{
						prop: "updateTime",
						label: "最後修改",
					},
					{
						prop: "updateUserName",
						label: "最後修改人員",
					},
				],
			],
			rules: {
				name: [
					{ required: true, message: "請輸入姓名", trigger: "blur" },
				],
				relation: [
					{ required: true, message: "請選擇受益人關係", trigger: "change" },
				],
				reason: [
					{ required: false,message: "請輸入原因", trigger: "blur"},
				],
			},
			account: "",
			show: false,
			// 取申請人資料失敗（例如年齡不符方案級距）時鎖住暫存／送出
			memberInfoError: false,
			listDisplay: false,
			enumData: {
				insPlanPayMethod: [],
				memberGroup: [],
			},
		};
	},
	created() {
		this.getData();
	},
	mounted() {
		const vm = this;
		$(".min_go_date").datepicker({
			changeYear: true,
			changeMonth: true,
			currentText: "今天",
			dateFormat: "Rmmdd",
			showButtonPanel: true,
			yearRange: "1912:c+10",
			onSelect(data) {
				let key = $(this)[0].className.split(" ")[2];
				if (data) {
					vm.recordToEdit[key] =
						parseInt(data.split("-")[0]) +
						1911 +
						"-" +
						data.slice(4);
				}
			},
		});
	},
	watch: {
		$route(to, from) {
			this.getData();
		},
		"recordToEdit.memberId": {
			handler(newKey) {
				if (newKey !== 0) {
					// 初次載入由 getData 統一查詢，避免重複請求並蓋掉申請單既有資料
					if (!this.isInitLoading) {
						this.getMemberData(
							0,
							this.recordToEdit.memberId,
							this.recordToEdit.insPlanSubId,
							this.recordToEdit.insPlanYearId,
							true
						);
					}
					if (this.recordToEdit.memberPayType == 2) {
						// 切換社員 且付款方式為備轉金 取的memberGroup
						this.getMemberGroup();
					}
					this.getBalance();
				}
			},
		},
		"recordToEdit.insPlanSubId": {
			handler(newKey) {
				let pos = this.subDataList.findIndex(
					(sub) => sub.id === this.recordToEdit.insPlanSubId
				);
				this.subFee = pos === -1 ? 0 : this.subDataList[pos].premium;
				// 切換子方案時再檢查一次年齡
				if (this.recordToEdit.memberId !== 0 && !this.isInitLoading) {
					this.getMemberData(
						0,
						this.recordToEdit.memberId,
						this.recordToEdit.insPlanSubId,
						this.recordToEdit.insPlanYearId,
						true
					);
				}
				if (newKey) {
					this.getEffectiveList(
						this.recordToEdit.insPlanYearId,
						newKey
					);
				}
			},
		},
		"recordToEdit.insPlanYearId": {
			handler(newKey) {
				let pos = this.subDataList.findIndex(
					(sub) => sub.id === this.recordToEdit.insPlanSubId
				);
				if (
					pos != -1 &&
					this.subDataList[pos].insPlanYearId !==
						this.recordToEdit.insPlanYearId
				) {
					this.recordToEdit.insPlanSubId = "";
					this.recordToEdit.memberId = 0;
					this.$refs.memberGet.chooseMember.memberId.showLabel = "";
					this.show = false;
				}
				this.subData = this.subDataList.filter((item) => {
					if (item.insPlanYearId == newKey) {
						return item;
					}
				});
			},
		},
		"currentEdit.relation": {
			handler(newKey) {
				// 關係改變時，重置輸入的其他關係
				if (newKey != 7) {
					this.currentEdit.relationOther = "";
				}

				// 兄弟姊妹或其他的話，需要填入原因
				if (newKey == 5 || newKey == 7) {
					this.rules.reason[0].required = true;
				} else {
					this.rules.reason[0].required = false;
				}
				
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate();
				});
			},
		},
		"recordToEdit.bnfType": {
			handler(newVal) {
				if (newVal == 2) {
					this.listDisplay = false;
				} else {
					this.listDisplay = true;
				}
			},
		},
	},
	methods: {
		getBnfEnumData(item) {
			this.bnfDataList = Object.keys(item.insBnfRelation).map((items) => {
				return {
					label: item.insBnfRelation[items],
					value: Number(items),
				};
			});
		},
		// 受益人欄位驗證
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveDialogEdit();
				} else {
					this.$message.closeAll();
					this.$message({
						type: "error",
						message: `請輸入必填欄位`,
						duration: 5000,
					});
				}
			});
		},
		otherValidate(rules) {
			Object.keys(this.rules).find((item) => {
				if (!this.currentEdit[item]) {
					if (this.rules[item][0].required) {
						this.$message.closeAll();
						this.$message({
							type: "error",
							message: `${this.rules[item][0].message}`,
							duration: 5000,
						});
						return;
					}
				}
			});
		},
		getData() {
			let url = API[this.api] + `?id=${this.id === "new" ? 0 : this.id}`;
			url += `&insPlanMainCode=${this.$route.params.code}&type=plus`;

			const thenCB = (json) => {
				let newObj = {
					...json.resultData.data,
					insPlanPaySourceMemberId:
						json.resultData.data.memberPaySourceMemberId,
					subsidyAmount: this.$addcomma(
						json.resultData.data.subsidyAmount
					),
				};
				this.isInitLoading = true;
				this.recordToEdit = Object.assign(
					{},
					this.recordToEdit,
					newObj
				);
				// 原始日期(2025-01-01 00:00:00)會讓下拉選單無法正常顯示
				if (newObj.insEffectiveDate) {
					this.recordToEdit.insEffectiveDate = newObj.insEffectiveDate.split(" ")[0]
				}
				this.recordToEdit.insPlanMainCode = this.$route.params.code;
				this.renderAgent(json.resultData.enumData);
				if (this.id !== "new") {
					this.getMemberData(
						"",
						this.recordToEdit.memberId,
						this.recordToEdit.insPlanSubId,
						this.recordToEdit.insPlanYearId,
						//不要蓋掉修改的資料
						false
					);
				}
				this.underwriteStatusAdd =
					json.resultData.enumData.insPlanUnderwriteStatusAdd;
				this.cardSendStatus = this.renderEnum(
					json.resultData.enumData.insPlanApplyCardSendStatus
				);
				this.refoundStatus =
					json.resultData.enumData.insPlanApplyRefoundStatus;
				this.addDocStatus =
					json.resultData.enumData.insPlanApplyAddDocStatus;
				this.isSubmit = this.recordToEdit.isSubmit == 1;
				// 送出後基本資料一律鎖定，後端 Update 也會擋下已送出的申請件（WM0138）
				this.formType.find(
					(item) => item.key === "memberId"
				).disabled = this.isSubmit;

				this.enumData = json.resultData.enumData;
				// 保險年度
				let year =
					json.resultData.enumData.insPlanYear.filter((item) => {
						return item.id == this.currentEdit.insPlanYearId;
					})[0] || "";
				this.currentEdit.insPlanYear = year.year - 1911 || 0;

				// 付款方式
				this.enumData.insPlanPayMethod = this.handleEnum(
					json.resultData.enumData.insPlanPayMethod
				);
				// 補件通知內容
				this.addDocNotices = json.resultData.addDocNotices;

				if (this.id !== "new") {
					this.query.insPlanMemberApplyId = this.$route.params.subId;
					if (this.recordToEdit.bnfType !== 2) {
						this.listDisplay = true;
					}
				}
				this.setDateValue();
				// watcher 會在本次 tick 結束時統一觸發，等它們跑完才解除載入旗標
				this.$nextTick(() => {
					this.isInitLoading = false;
				});
			};
			this.mAxiosGet(url, thenCB);
		},
		renderEnum(enumData) {
			return Object.keys(enumData).map((key) => {
				return { label: enumData[key], value: parseInt(key) };
			});
		},
		setDateValue() {
			setTimeout(() => {
				this.setTimeKey.forEach((item) => {
					if (this.recordToEdit[item]) {
						$(`.${item}`).val(
							`${
								parseInt(this.recordToEdit[item]) - 1911 < 100
									? `0${
											parseInt(this.recordToEdit[item]) -
											1911
									  }${
											this.recordToEdit[item]
												.slice(4)
												.split(" ")[0]
									  }`
									: `${
											parseInt(this.recordToEdit[item]) -
											1911
									  }${
											this.recordToEdit[item]
												.slice(4)
												.split(" ")[0]
									  }` || ""
							}`
						);
					}
				});
			}, 1);
		},
		renderAgent(enumData) {
			// 受益人分配方式額外處理
			let arr = [];
			Object.keys(enumData.bnfType).map((key) => {
				arr.push({
					label: enumData.bnfType[key],
					value: parseInt(key),
				});
			});
			this.bnf = arr.reverse();
			this.yearData = enumData.insPlanYear.map((item) => {
				return {
					year: item.year - 1911,
					id: Number(item.id),
				};
			});
			this.subDataList = enumData.insPlanSub;
		},
		/**
		 * 取得申請人資料，順便由後端驗證年齡是否符合方案級距
		 * @param {string|number} memberAccount 社員帳號，空值時後端改用 memberId 查詢
		 * @param {number} memberId 社員 id
		 * @param {number} insPlanSubId 子方案 id
		 * @param {number} insPlanYearId 申請年度 id
		 * @param {boolean} isReplaceModify 是否覆寫表單上的社員基本資料
		 * @returns {Promise<void>}
		 */
		async getMemberData(
			memberAccount,
			memberId,
			insPlanSubId,
			insPlanYearId,
			isReplaceModify
		) {
			if (insPlanSubId == null || isNaN(parseInt(insPlanSubId))) {
				this.$message.error("尚未選擇子方案");
				this.memberInfoError = true;
				return;
			}

			// 帶上申請件 id，後端才能沿用存檔的申請類型而不是每次重新推導
			const applyId = this.id === "new" ? 0 : this.id;
			const url =
				API.coopInsPlanMemberApply +
				`?action=getMemberInfo&id=${applyId}&account=${memberAccount}&memberId=${memberId}&insPlanMainCode=${this.$route.params.code}&insPlanSubId=${insPlanSubId}&insPlanYearId=${insPlanYearId}`;

			try {
				const json = await this.mAxiosGet(url);
				this.member = Object.assign(
					{},
					this.member,
					json.resultData.data
				);
				this.recordToEdit.applyType = json.resultData.data.applyType;
				this.recordToEdit.memberId = json.resultData.data.memberId;
				if (isReplaceModify) {
					this.recordToEdit.name = json.resultData.data.name;
					this.recordToEdit.sex = json.resultData.data.sex;
					this.recordToEdit.idNumber = json.resultData.data.idNumber;
					this.recordToEdit.birthday = json.resultData.data.birthday;
					this.setDateValue();
					this.recordToEdit.age = json.resultData.data.age;
					// this.recordToEdit.title = json.resultData.data.jobTitle;
					// this.recordToEdit.job = json.resultData.data.job;
				}

				this.account = json.resultData.data.account;

				let tmpGender = json.resultData.enumData.gender;

				this.genderData = Object.keys(tmpGender).map((gend) => {
					return { label: tmpGender[gend], value: parseInt(gend) };
				});
				this.show = true;
				this.memberInfoError = false;
			} catch (error) {
				// 錯誤訊息由 mixin 統一顯示；這裡把申請人資料收掉並鎖住暫存／送出，
				// 避免年齡不符方案級距等狀況還被存進資料庫
				this.show = false;
				this.memberInfoError = true;
			}
		},
		editData(id, row) {
			// edit
			this.currentEdit = {
				bnfSeq: "",
				name: "",
				relation: "",
				relationOther: "",
				phone: "",
				idNumber: "",
				addr: "",
				reason: "",
			};
			this.dialogListForm = true;
			if (id !== "new") {
				this.currentEdit = Object.assign({}, row);
			}
			this.$nextTick(() => {
				this.$refs.ruleForm.clearValidate();
			});
		},
		submit() {
			this.$confirm(
				"是否確認資料已填寫完畢(包含受益人，如已選擇法定繼承人則免填)",
				"提示訊息",
				{
					confirmButtonText: "是",
					cancelButtonText: "否",
					type: "warning",
				})
				.then(
					async () => {
						// 先 await 暫存，避免 update 與 submit 並行造成 race
						try {
							await this.saveMainEdit({ silent: true });

							let url = API.coopInsPlanMemberApply + `?action=submit`;
							let form = this.buildMainFormData();
							form.append("id", this.id);
							await this.mAxiosPost(url, form);

							this.showAjaxSuccessMsg();
							this.getData();
						} catch (error) {
							console.error(error);
						}
					},
					() => {
						// 只接 $confirm 的取消，送出流程自己的錯誤不該被誤報成使用者取消
						this.$message({
							type: "warning",
							message: "已取消送出",
							duration: 5000,
						});
					}
				);
		},
		async saveMainEdit(options = {}) {
			const silent = options.silent === true;
			let url = API.coopInsPlanMemberApply;
			let form = this.buildMainFormData();
			if (this.id !== "new" && this.id !== 0 && this.id) {
				form.append("id", this.id);
				url += `?action=update`;
			} else {
				url += `?action=append`;
			}

			const json = await this.mAxiosPost(url, form);
			this.id = json.resultData.id;
			if (!silent) {
				this.showAjaxSuccessMsg();
				this.$router.push({
					name: this.$route.name,
					params: { subId: json.resultData.id },
				});
			}
			return json;
		},
		buildMainFormData() {
			let form = new FormData();

			form.append("bnfType", this.recordToEdit.bnfType || 0);
			form.append("insPlanMainCode", this.recordToEdit.insPlanMainCode || this.$route.params.code);
			form.append("insPlanSubId", this.recordToEdit.insPlanSubId);
			form.append("insPlanYearId", this.recordToEdit.insPlanYearId);
			form.append("memberId", this.recordToEdit.memberId);

			// 統一預設為 0，避免後端數值轉型報錯
			form.append("subsidyAmount", this.$removeComma(this.recordToEdit.subsidyAmount) || 0); 
			form.append("subsidyVoucherCode", this.recordToEdit.subsidyVoucherCode || "");
			form.append("subsidyVoucherDate", this.recordToEdit.subsidyVoucherDate || ""); 

			form.append("name", this.recordToEdit.name || "");
			form.append("sex", this.recordToEdit.sex || "");
			form.append("idNumber", this.recordToEdit.idNumber || "");
			form.append("birthday", this.recordToEdit.birthday || "");
			form.append("age", this.recordToEdit.age || 0);
			form.append("title", this.recordToEdit.title || "");
			form.append("job", this.recordToEdit.job || "");
			form.append("memberPayType", this.recordToEdit.memberPayType || "");
			form.append("memberPaySourceMemberId", this.recordToEdit.insPlanPaySourceMemberId || "");
			form.append("balance", this.recordToEdit.balance || 0);

			return form;
		},
		saveDialogEdit() {
			let url = API[this.apiBnf];
			let form = new FormData();
			if (
				this.currentEdit.id !== "new" &&
				this.currentEdit.id !== 0 &&
				this.currentEdit.id
			) {
				form.append("id", this.currentEdit.id);
				url += `?action=update`;
			} else {
				url += `?action=append`;
			}
			form.append("bnfSeq", this.currentEdit.bnfSeq || 0);
			form.append("idNumber", this.currentEdit.idNumber || "");
			form.append("reason", this.currentEdit.reason || "");
			form.append("name", this.currentEdit.name || "");
			form.append("relation", this.currentEdit.relation || "");
			form.append("relationOther", this.currentEdit.relationOther || "");
			form.append("phone", this.currentEdit.phone || "");
			form.append("addr", this.currentEdit.addr || "");
			form.append("insPlanMemberApplyId", this.id);
			// form.append('year', this.currentEdit.year !== undefined ? this.currentEdit.year : '');
			// form.append('periodStart', this.currentEdit.periodStart !== undefined ? this.currentEdit.periodStart : '');
			// form.append('periodEnd', this.currentEdit.periodEnd !== undefined ? this.currentEdit.periodEnd : '');
			// form.append('applicationStart', this.currentEdit.applicationStart !== undefined ? this.currentEdit.applicationStart : '');
			// form.append('applicationEnd', this.currentEdit.applicationEnd !== undefined ? this.currentEdit.applicationEnd : '');

			let thenCB = (json) => {
				this.showAjaxSuccessMsg();
				this.$refs.workbench.getData();
			};
			this.mAxiosPost(url, form, thenCB);
			this.dialogListForm = false;
		},
		back() {
			this.$router.push({
				name: "agent_plusroster",
			});
		},
		getEffectiveList(insPlanYearId, insPlanSubId) {
			//取得預計生效日清單
			const url =
				API.coopInsPlanMemberApply +
				`?action=getEffectiveList&insPlanYearId=${insPlanYearId}&insPlanSubId=${insPlanSubId}`;

			const thenCB = (json) => {
				let data = json.resultData.data;
				if (!this.isSubmit || !this.recordToEdit.insEffectiveDate) {
					this.recordToEdit.insEffectiveDate = data[0];
				}
				this.effectiveDataList = data;
			};
			this.mAxiosGet(url, thenCB);
		},
		getBalance(memberId = 0) {
			if (this.recordToEdit.memberId === 0) { 
				this.$message.error("請選擇申請人");
				return;
			}
			this.showMemberGroupSelect = false;
			this.recordToEdit.balance = 0;
			// 切換付款方式非現金收款 取得結餘
			if (
				this.recordToEdit.memberPayType !== 1 &&
				this.recordToEdit.memberPayType
			) {
				// 非備轉金 須清空 insPlanPaySourceMemberId
				if (this.recordToEdit.memberPayType !== 2) {
					delete this.recordToEdit.insPlanPaySourceMemberId;
				} else {
					// 切換為備轉金 並且有選擇申請人 呼叫 memberGroup
					if (memberId == 0) {
						this.getMemberGroup();
					} else {
						this.showMemberGroupSelect = true;
					}
				}
				const url =
					API["coopInsPlanMemberApplyRenew"] + "?action=getBalance";
				const form = new FormData();
				const thenCB = (json) => {
					this.$set(
						this.recordToEdit,
						"balance",
						json.resultData.data || 0
					);
				};
				form.append("memberId", memberId || this.recordToEdit.memberId);
				form.append(
					"insPlanPayMethod",
					this.recordToEdit.memberPayType
				);
				form.append("insPlanMainCode", this.$route.params.code);

				this.mAxiosPost(url, form, thenCB);
			} else {
				// 現金收款 將結餘歸零
				this.recordToEdit.balance = 0;
			}
		},
		resetAmount(amount) {
			return (this.recordToEdit.subsidyAmount = this.$addcomma(
				this.$removeComma(amount)
			));
		},
		getMemberGroup() {
			// 取得 memberGroup
			const url = API.member + "?action=getSameGroupMemberList";
			const form = new FormData();
			const thenCB = (json) => {
				this.enumData.memberGroup = json.resultData.data;
				this.recordToEdit.insPlanPaySourceMemberId = this.recordToEdit.memberId;
				if (this.enumData.memberGroup.length === 0) {
					this.showMemberGroupSelect = false;
				} else {
					this.showMemberGroupSelect = true;
				}
			};
			form.append("memberId", this.recordToEdit.memberId);

			this.mAxiosPost(url, form, thenCB);
		},
		sendCardSendDate() {
			const url = API.coopInsPlanMemberApply + "?action=sendCardSendDate";
			const form = new FormData();
			form.append("insPlanMemberApplyId", this.id);
			form.append(
				"insCardSendStatus",
				this.recordToEdit.insCardSendStatus
			);
			const thenCB = (json) => {
				this.showAjaxSuccessMsg();
			};
			this.mAxiosPost(url, form, thenCB);
		},
		goMember() {
			const { href } = this.$router.resolve({
				name: "member_edit",
				params: {
					id: this.recordToEdit.memberId,
				},
			});
			window.open(href, "_blank", "toolbar=yes, width=1300, height=900");
		},
	},
};
</script>
<style lang="scss" scope>
table.info td {
	padding-top: 0;
	padding-bottom: 0;
}
.listFormSet {
	.block-content {
		padding: 0;
	}
}
.el-message-box {
	.el-message-box__content {
		font-size: 18px;
	}
}
.disblock {
	display: block;
}
</style>